<template>

  <div>
    <PrivacypolicyCn v-if="PrivacypolicyCn"></PrivacypolicyCn>
    <PrivacypolicyTw v-if="PrivacypolicyTw"></PrivacypolicyTw>
    <PrivacypolicyUs v-if="PrivacypolicyUs"></PrivacypolicyUs>
  </div>
</template>
<script>
  import PrivacypolicyCn from "@/components/PrivacypolicyCn.vue";
  import PrivacypolicyTw from "@/components/PrivacypolicyTw.vue";
  import PrivacypolicyUs from "@/components/PrivacypolicyUs.vue";
  export default {
    components: {
      PrivacypolicyCn,
      PrivacypolicyTw,
      PrivacypolicyUs,
    },
    data() {
      return {
        PrivacypolicyCn: false,
        PrivacypolicyTw: false,
        PrivacypolicyUs: false,
      }
    },
    mounted() {
      if (localStorage.getItem('lang') == 'zh-cn') {
        this.PrivacypolicyCn = true;
      } else if (localStorage.getItem('lang') == 'zh-tw') {
        this.PrivacypolicyTw = true;
      } else if (localStorage.getItem('lang') == 'en-us') {
        this.PrivacypolicyUs = true;
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/Privacypolicy.vue